import { Platform, Orientation } from "consts";

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "50%",
    [Orientation.LANDSCAPE]: "26%",
  },
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "70%",
    [Orientation.LANDSCAPE]: "60%",
  },
};

export const ContainerHeight = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "390px",
    [Orientation.LANDSCAPE]: "390px",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "390px",
    [Orientation.LANDSCAPE]: "390px",
  },
};

export const ContainerMarginBottom = {
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "40",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "30",
    [Orientation.LANDSCAPE]: "30",
  },
};
